
      import '@folkjs/labs/standalone/folk-space';
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-presence';

      // DOM elements
      const space = document.getElementById('space');
      const debugInfo = document.getElementById('debug-info');
      const collaboratorList = document.getElementById('collaborator-list');
      const pointers = document.getElementById('pointers');

      // State tracking
      let isEditingName = false;
      let isColorPickerOpen = false;

      // Color options
      const colorOptions = [
        '#e74c3c',
        '#e67e22',
        '#f1c40f',
        '#2ecc71',
        '#1abc9c',
        '#3498db',
        '#9b59b6',
        '#34495e',
        '#7f8c8d',
        '#d35400',
        '#27ae60',
        '#2980b9',
        '#8e44ad',
      ];

      // Initialize
      updateDisplays(1, { x: 0, y: 0 });

      // Set up collaborator list updates
      if (pointers) {
        setTimeout(() => updateCollaboratorList(), 1000);
        setInterval(updateCollaboratorList, 2000);
      }

      function updateCollaboratorList() {
        if (!pointers?.automerge || isEditingName || isColorPickerOpen) return;

        pointers.automerge.whenReady((doc) => {
          if (!doc.pointers) return;

          collaboratorList.innerHTML = '';
          const allPointers = Object.values(doc.pointers);
          const userIdentity = pointers.identity;
          const yourPointer = allPointers.find((p) => p.id === userIdentity.peerId);
          const otherPointers = allPointers
            .filter((p) => p.id !== userIdentity.peerId)
            .sort((a, b) => a.name.localeCompare(b.name));

          if (yourPointer) {
            addCollaboratorToList(yourPointer, true);
          }

          otherPointers.forEach((p) => addCollaboratorToList(p, false));
        });
      }

      function addCollaboratorToList(pointer, isYou) {
        const li = document.createElement('li');
        li.className = 'collaborator-item' + (isYou ? ' you' : '');

        const colorSpan = document.createElement('span');
        colorSpan.className = 'collaborator-color';
        colorSpan.style.backgroundColor = pointer.color;

        const nameSpan = document.createElement('span');
        nameSpan.className = 'collaborator-name';
        nameSpan.textContent = pointer.name + (isYou ? ' (you)' : '');

        li.appendChild(colorSpan);
        li.appendChild(nameSpan);

        if (isYou) {
          nameSpan.addEventListener('click', () => startEditingName(nameSpan, pointer.name));
          colorSpan.addEventListener('click', (event) => {
            event.stopPropagation();
            showColorPicker(colorSpan, pointer.color);
          });
        }

        collaboratorList.appendChild(li);
      }

      function showColorPicker(colorSpan, currentColor) {
        isColorPickerOpen = true;

        const colorPicker = document.createElement('div');
        colorPicker.className = 'color-picker';

        const rect = colorSpan.getBoundingClientRect();
        colorPicker.style.left = rect.left - 50 + 'px';
        colorPicker.style.top = rect.bottom + 5 + 'px';

        colorOptions.forEach((color) => {
          const colorOption = document.createElement('div');
          colorOption.className = 'color-option';
          colorOption.style.backgroundColor = color;

          if (color === currentColor) {
            colorOption.style.boxShadow = '0 0 0 2px #000';
          }

          colorOption.addEventListener('click', () => {
            if (pointers) {
              pointers.color = color;
              if (document.body.contains(colorPicker)) {
                document.body.removeChild(colorPicker);
              }
              isColorPickerOpen = false;
              colorSpan.style.backgroundColor = color;
              setTimeout(() => updateCollaboratorList(), 100);
            }
          });

          colorPicker.appendChild(colorOption);
        });

        function handleClickOutside(e) {
          if (!colorPicker.contains(e.target) && e.target !== colorSpan) {
            if (document.body.contains(colorPicker)) {
              document.body.removeChild(colorPicker);
            }
            document.removeEventListener('click', handleClickOutside);
            isColorPickerOpen = false;
            setTimeout(() => updateCollaboratorList(), 100);
          }
        }

        setTimeout(() => document.addEventListener('click', handleClickOutside), 10);
        document.body.appendChild(colorPicker);
      }

      function startEditingName(nameSpan, currentName) {
        isEditingName = true;

        const input = document.createElement('input');
        input.className = 'name-input-field';
        input.type = 'text';
        input.value = currentName;
        input.placeholder = 'Enter your name';
        input.setAttribute('autocomplete', 'new-password');
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('autocapitalize', 'off');
        input.setAttribute('spellcheck', 'false');
        input.setAttribute('data-form-type', 'other');

        const parent = nameSpan.parentNode;
        parent.replaceChild(input, nameSpan);
        input.focus();

        function saveName() {
          const newName = input.value.trim();
          if (newName && pointers) {
            pointers.username = newName;
            setTimeout(() => {
              isEditingName = false;
              updateCollaboratorList();
            }, 100);
          } else {
            parent.replaceChild(nameSpan, input);
            isEditingName = false;
          }
        }

        input.addEventListener('blur', saveName);
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            saveName();
          } else if (event.key === 'Escape') {
            parent.replaceChild(nameSpan, input);
            isEditingName = false;
          }
        });
      }

      if (space) {
        space.onTransformChange = (scale, position) => {
          updateDisplays(scale, position);
        };
      }

      function updateDisplays(scale, position) {
        debugInfo.textContent = `scale: ${scale.toFixed(2)} | pos: ${Math.round(position.x)}, ${Math.round(position.y)}`;
      }
    